import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { LayoutContext } from '../../context/LayoutProvider';
import useUser from '../../store/user';
import { shallow } from 'zustand/shallow';

const VideoPlayer = ({ id, src, option, type, width }) => {
  const { isMobile } = useContext(LayoutContext);
  const videoRef = useRef(null);
  const { user, fetchUser } = useUser(
    state => ({
      user: state.user,
      fetchUser: state.fetchUser,
    }),
    shallow
  );

  useEffect(() => {
    if (!videoRef.current) return;

    videoRef.current.muted = true;
    videoRef.current
      .play()
      .then()
      .catch()
      .finally(() => {
        if (!videoRef.current) return;

        videoRef.current.loop = true;
        videoRef.current.muted = true;
        videoRef.current.currentTime = 0;
        videoRef.current.play();
      });
  }, [user]);

  return (
    <Video id={id} ref={videoRef} width={width} isMobile={isMobile} {...option}>
      <source src={src} type={type} />
    </Video>
  );
};

VideoPlayer.propTypes = {
  src: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  option: PropTypes.object,
};

export default VideoPlayer;

const Video = styled.video`
  &[poster] {
    height: 100%;
    width: 100%;
  }
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 100%;
          height: 100%;
          object-fit: cover;
        `
      : css`
          width: ${({ width }) => (width ? width : '115%')};
          object-fit: cover;
        `};
`;
